import axios from "axios";
import publicIp from 'public-ip';


import {
    VDR_HOME_COMPANIES_REQUEST,
    VDR_HOME_COMPANIES_SUCCESS,
    VDR_HOME_COMPANIES_SUCCESS_FILTER,
    VDR_HOME_COMPANIES_FAIL,
    VDR_GROUPS_REQUEST,
    VDR_GROUPS_SUCCESS,
    VDR_GROUPS_FAIL,
    VDR_COMPANY_REQUEST,
    VDR_COMPANY_SUCCESS,
    VDR_COMPANY_FAIL,
    VDR_LEVEL_REQUEST,
    VDR_LEVEL_SUCCESS,
    VDR_LEVEL_FAIL,
    VDR_HOME_REQUEST,
    VDR_HOME_SUCCESS,
    VDR_HOME_FAIL,
    VDR_UPLOAD_IMAGE_REQUEST,
    VDR_UPLOAD_IMAGE_SUCCESS,
    VDR_UPLOAD_IMAGE_FAIL,
    PUBLIC_IP_REQUEST,
    PUBLIC_IP_SUCCESS,
    PUBLIC_IP_FAIL,
    VDR_SINGLE_COMPANY_REQUEST,
    VDR_SINGLE_COMPANY_SUCCESS,
    VDR_SINGLE_COMPANY_FAIL,
    PDF_LINK_REQUEST,
    PDF_LINK_SUCCESS,
    MEDIA_MODEL_REQUEST,
    MEDIA_MODEL_OPEN,
    MEDIA_MODEL_CLOSE,
    MEDIA_DATA_REQUEST,
    MEDIA_DATA_SUCCESS,
    MEDIA_DATA_FAIL,
    DATA_20_YEARS_REQUEST,
    DATA_20_YEARS_SUCCESS,
    DATA_20_YEARS_FAIL,
    DATA_20_YEARS_QUARTERLY_REQUEST,
    DATA_20_YEARS_QUARTERLY_SUCCESS,
    DATA_20_YEARS_QUARTERLY_FAIL,
    PEER_TO_PEER_REQUEST,
    PEER_TO_PEER_SUCCESS,
    PEER_TO_PEER_FAIL,
    SORT_DATA_REQUEST,
    SORT_DATA_SUCCESS,
    SORT_DATA_FAIL,
    SORT_DATA_UPDATE_REQUEST,
    SORT_DATA_UPDATE_SUCCESS,
    SORT_DATA_UPDATE_FAIL,
    VDR_HOME_SUCCESS_FILTER,
    FAVORITE_REQUEST,
    FAVORITE_SUCCESS,
    FAVORITE_FAIL,
    EMPLOYEE_REQUEST,
EMPLOYEE_SUCCESS,
EMPLOYEE_FAIL,
SEGMENT_REQUEST,
SEGMENT_SUCCESS,
SEGMENT_FAIL,
SEGMENT_ASSIGN_REQUEST,
SEGMENT_ASSIGN_SUCCESS,
SEGMENT_ASSIGN_FAIL,
QUARTERLY_REVIEW_REQUEST,
QUARTERLY_REVIEW_SUCCESS,
QUARTERLY_REVIEW_FAIL,
QUARTERLY_SEGMENT_REQUEST,
QUARTERLY_SEGMENT_SUCCESS,
QUARTERLY_SEGMENT_RESET,
QUARTERLY_SEGMENT_FAIL,
} from './../../constants/VdrConstants';

import {
    vdrLevelRequest,
    vdrGroupRequest,
    vdrCompanyRequest,
    vdrHomeRequest,
    vdrImageUploadRequest,
    geoLocationDb,
    vdrSingleCompanyRequest,
    vdrMediaDataRequest,
    vdrData20YearsRequest,
    vdrPeerToPeerRequest,
    vdrSortDataRequest,
    vdrSortDataUpdateRequest,
    vdrFavoriteRequest,
    vdrEmployeeRequest,
    vdrSegmentRequest,
    vdrAssignEmployeeRequest,
    vdrMediaRequest,
    filesLogRequest,
    priceActionRequest,
    vdrMediaGroupRequest,
    PriceIndexRequest,
    vdrForensicRequest,
    DateAPI,
    vdrSegmentAssignRequest,
    quarterlyReviewRequest,
    quarterlySegmentRequest,
    quarterlySegmentStandaloneRequest,
    vdrHomeCompaniesRequest,
} from "../../utils/VdrRequest";
import { useSelector } from "react-redux";
import { omkaraUserListRequest } from "../../utils/userRequest";


export const PriceActionFilterAction = (data) => async (dispatch) => {
    try {
        dispatch({ type: 'PriceActionFilterRequest' });
        dispatch({ type: 'PriceActionFilterSuccess', payload: data });
    } catch (error) {
        var errorMsg;
        dispatch({ type: 'PriceActionFilterFailure', payload: errorMsg });
    }
};


export const priceActionFilters = (inputsArray) => {
    // console.log(inputsArray);
    const filterArray = {
        "Index": inputsArray.index?.value1,
        "Sector": inputsArray.sectors?.value1,
        "Industry": inputsArray.industry?.value1,
        "Portfolio":inputsArray.portfolio.value1,
        "Company": inputsArray.company?.value1,
        "Market_Cap": [inputsArray.Market_Cap?.value1, inputsArray.Market_Cap?.value2],
        "TTM_P_E": [inputsArray.TTM_PE?.value1, inputsArray.TTM_PE?.value2],
        "TTM_P_B": [inputsArray.TTM_PBV?.value1, inputsArray.TTM_PBV?.value2],
        "Chg_from_week52_highPer": inputsArray.Chg_from_week52_highPer?.value1,
        "Chg_from_week52_lowPer": inputsArray.Chg_from_week52_lowPer?.value1,
        "ChangeAllTimeHigh": inputsArray.ChangeAllTimeHigh?.value1
    }
    // const filterArray = {
    //     "Index": [
    //         "100"
    //     ],
    //     "Sector": [],
    //     "Industry": [],
    //     "Company": [],
    //     "Market_Cap": [],
    //     "TTM_P_E": [
    //         ">10"
    //     ],
    //     "TTM_P_B": [
    //         ">10"
    //     ],
    //     "Chg_from_week52_highPer": "",
    //     "Chg_from_week52_lowPer": "",
    //     "ChangeAllTimeHigh": ""
    // };
    return filterArray;
}

export const MessageAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: 'MessageRequest', payload: req });
    } catch (error) {
        console.log(error);
    }
};

export const GetOmakaraUsersAction = (req) => async (dispatch) => {
    try {
        const red = await omkaraUserListRequest();
        console.log('red >>> ', red.data);
        dispatch({ type: 'getOmakaraUsers', payload: red.data });
    } catch (error) {
        console.log(error);
    }
};

export const PriceActionAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: 'PriceActionRequest' });
        const { data } = await priceActionRequest(req);
        dispatch({ type: 'PriceActionSuccess', payload: data });
    } catch (error) {
        var errorMsg;
        if (error.response.data?.Message) {
            errorMsg = error.response.data?.Message;
        } else {
            errorMsg = error.response.data?.msg;
        }
        dispatch({ type: 'PriceActionFailure', payload: errorMsg });
    }
};


export const dateAPIAction = () => async (dispatch) => {
    try {
        dispatch({ type: 'dateAPIRequest' });
        const { data } = await DateAPI();
        dispatch({ type: 'dateAPISuccess', payload: data });
    } catch (error) {
        var errorMsg;
        if (error.response.data?.Message) {
            errorMsg = error.response.data?.Message;
        } else {
            errorMsg = error.response.data?.msg;
        }
        dispatch({ type: 'dateAPIFailure', payload: errorMsg });
    }
};


export const PriceIndexAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: 'PriceIndexRequest' });
        const { data } = await PriceIndexRequest(req);
        dispatch({ type: 'PriceIndexSuccess', payload: data });
    } catch (error) {
        var errorMsg;
        if (error.response.data?.Message) {
            errorMsg = error.response.data?.Message;
        } else {
            errorMsg = error.response.data?.msg;
        }
        dispatch({ type: 'PriceIndexFailure', payload: errorMsg });
    }
};


export const vdrGroupAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: VDR_GROUPS_REQUEST });
        const { data } = await vdrGroupRequest(req);
        dispatch({ type: VDR_GROUPS_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;
        if (error.response.data?.Message) {
            errorMsg = error.response.data?.Message;
        } else {
            errorMsg = error.response.data?.msg;
        }
        dispatch({ type: VDR_GROUPS_FAIL, payload: errorMsg });
    }
};


export const vdrUpdateGroupAction = (req) => async (dispatch) => {

    try {
        dispatch({ type: VDR_GROUPS_REQUEST });
        const { data } = await vdrGroupRequest(req);
        dispatch({ type: VDR_GROUPS_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;
        if (error.response.data?.Message) {
            errorMsg = error.response.data?.Message;
        } else {
            errorMsg = error.response.data?.msg;
        }
        dispatch({ type: VDR_GROUPS_FAIL, payload: errorMsg });
    }
};

export const vdrFavoriteAction = (req) => async (dispatch) => {

    
    try {
        
        dispatch({ type: FAVORITE_REQUEST });
        
        const { data } = await vdrFavoriteRequest(req);
        console.log(data);
        dispatch({ type: FAVORITE_SUCCESS, payload: data });
    } catch (error) {

        var errorMsg;
        if (error.response.data?.Message) {
            errorMsg = error.response.data?.Message;
        } else {
            errorMsg = error.response.data?.msg;
        }
        
        dispatch({ type: FAVORITE_FAIL, payload: errorMsg });
    }
};


export const vdrLevelAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: VDR_LEVEL_REQUEST });
        const { data } = await vdrLevelRequest(req);
        dispatch({ type: VDR_LEVEL_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;
        if (error.response.data?.Message) {
            errorMsg = error.response.data?.Message;
        } else {
            errorMsg = error.response.data?.msg;
        }
        dispatch({ type: VDR_LEVEL_FAIL, payload: errorMsg });
    }
};




export const vdrCompanyAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: VDR_COMPANY_REQUEST });
        const { data } = await vdrCompanyRequest(req);
        // console.log('data', data);
        dispatch({ type: VDR_COMPANY_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;

        console.log(error);
        // if (error.response.data?.Message) {
        //     errorMsg = error.response.data?.Message;
        // } else {
        //     errorMsg = error.response.data?.msg;
        // }
        dispatch({ type: VDR_COMPANY_FAIL, payload: errorMsg });
    }
};


export const vdrForensicAction = (req, actionFor) => async (dispatch) => {
    try {
        dispatch({ type: 'ForensicRequest' });
        const { data } = await vdrForensicRequest(req);
        // console.log('data', data);
        if(actionFor == 'add'){
            dispatch({ type: 'ForensicSuccess', payload: data });
        }else{
            dispatch({ type: 'ForensicSuccess', payload: data });
        }
    } catch (error) {
        var errorMsg;

        console.log(error);
        // if (error.response.data?.Message) {
        //     errorMsg = error.response.data?.Message;
        // } else {
        //     errorMsg = error.response.data?.msg;
        // }
        dispatch({ type: VDR_COMPANY_FAIL, payload: errorMsg });
    }
};


export const vdrAssignEmployeeAction = (req, actionFor) => async (dispatch) => {
    try {
        dispatch({ type: 'AssignEmployeeRequest' });
        const { data } = await vdrAssignEmployeeRequest(req);
        // console.log('data', data);
        if(actionFor == 'add'){
            dispatch({ type: 'AssignEmployeeSuccess', payload: data });
        }else{
            dispatch({ type: 'AssignEmployeeSuccess', payload: data });
        }
    } catch (error) {
        var errorMsg;

        console.log(error);
        // if (error.response.data?.Message) {
        //     errorMsg = error.response.data?.Message;
        // } else {
        //     errorMsg = error.response.data?.msg;
        // }
        dispatch({ type: VDR_COMPANY_FAIL, payload: errorMsg });
    }
};


export const vdrMediaGroupAction = (req, actionFor) => async (dispatch) => {
    try {
        dispatch({ type: 'vdrMediaGroupRequest' });
        const { data } = await vdrMediaGroupRequest(req);
        // console.log('data', data);
        if(actionFor == 'add'){
            dispatch({ type: 'vdrMediaGroupSuccess', payload: data });
        }else{
            dispatch({ type: 'vdrMediaGroupSuccess', payload: data });
        }
    } catch (error) {
        var errorMsg;

        console.log(error);
        // if (error.response.data?.Message) {
        //     errorMsg = error.response.data?.Message;
        // } else {
        //     errorMsg = error.response.data?.msg;
        // }
        dispatch({ type: 'vdrMediaFail', payload: errorMsg });
    }
};

export const vdrMediaAction = (req, actionFor) => async (dispatch) => {
    try {
        dispatch({ type: 'vdrMediaRequest' });
        const { data } = await vdrMediaRequest(req);
        // console.log('data', data);
        if(actionFor == 'add'){
            dispatch({ type: 'vdrMediaSuccess', payload: data });
        }else{
            dispatch({ type: 'vdrMediaSuccess', payload: data });
        }
    } catch (error) {
        var errorMsg;

        console.log(error);
        // if (error.response.data?.Message) {
        //     errorMsg = error.response.data?.Message;
        // } else {
        //     errorMsg = error.response.data?.msg;
        // }
        dispatch({ type: 'vdrMediaFail', payload: errorMsg });
    }
};

export const filesLogAction = (req, actionFor) => async (dispatch) => {
    try {
        dispatch({ type: 'FilesLogRequest' });
        const { data } = await filesLogRequest(req);
        // console.log('data', data);
        if(actionFor == 'add'){
            dispatch({ type: 'FilesLogAdd', payload: data });
        }else{
            dispatch({ type: 'FilesLogSuccess', payload: data });
        }
    } catch (error) {
        var errorMsg;

        console.log(error);
        // if (error.response.data?.Message) {
        //     errorMsg = error.response.data?.Message;
        // } else {
        //     errorMsg = error.response.data?.msg;
        // }
        dispatch({ type: 'FilesLogFailure', payload: errorMsg });
    }
};


export const vdrHomeCompaniesAction = (req, req_type = "") => async (dispatch) => {
    try {
        dispatch({ type: VDR_HOME_COMPANIES_REQUEST });
        const { data } = await vdrHomeCompaniesRequest(req);
        if (req_type === 'filter') {
            dispatch({ type: VDR_HOME_COMPANIES_SUCCESS_FILTER, payload: data });
        } else {
            dispatch({ type: VDR_HOME_COMPANIES_SUCCESS, payload: data });
        }
    } catch (error) {
        var errorMsg;
        if (error.response.data?.Message) {
            errorMsg = error.response.data?.Message;
        } else {
            errorMsg = error.response.data?.msg;
        }
        dispatch({ type: VDR_HOME_COMPANIES_FAIL, payload: errorMsg });
    }
};

export const vdrHomeAction = (req, req_type = "") => async (dispatch) => {
    try {
        dispatch({ type: VDR_HOME_REQUEST });
        const { data } = await vdrHomeRequest(req);
        if (req_type === 'filter') {
            dispatch({ type: VDR_HOME_SUCCESS_FILTER, payload: data });
        } else {
            dispatch({ type: VDR_HOME_SUCCESS, payload: data });
        }
    } catch (error) {
        var errorMsg;
        if (error.response.data?.Message) {
            errorMsg = error.response.data?.Message;
        } else {
            errorMsg = error.response.data?.msg;
        }
        dispatch({ type: VDR_HOME_FAIL, payload: errorMsg });
    }
};


export const vdrUploadImageAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: VDR_UPLOAD_IMAGE_REQUEST });
        const { data } = await vdrImageUploadRequest(req);
        dispatch({ type: VDR_UPLOAD_IMAGE_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;
        if (error.response.data?.Message) {
            errorMsg = error.response.data?.Message;
        } else {
            errorMsg = error.response.data?.msg;
        }
        dispatch({ type: VDR_UPLOAD_IMAGE_FAIL, payload: errorMsg });
    }
};


export const vdrSingleCompanyAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: VDR_SINGLE_COMPANY_REQUEST });
        const { data } = await vdrSingleCompanyRequest(req);
        dispatch({ type: VDR_SINGLE_COMPANY_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;
        if (error.response.data?.Message) {
            errorMsg = error.response.data?.Message;
        } else {
            errorMsg = error.response.data?.msg;
        }
        console.log(errorMsg);
        dispatch({ type: VDR_SINGLE_COMPANY_FAIL, payload: errorMsg });
    }
};

export const vdrMediaDataAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: MEDIA_DATA_REQUEST });
        const { data } = await vdrMediaDataRequest(req);
        dispatch({ type: MEDIA_DATA_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;
        if (error.response.data?.Message) {
            errorMsg = error.response?.data?.Message;
        } else {
            errorMsg = error.response?.data?.msg;
        }
        // console.log('error',error.response);
        dispatch({ type: MEDIA_DATA_FAIL, payload: errorMsg });
    }
};

export const vdrData20YearsQuarterlyAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: DATA_20_YEARS_QUARTERLY_REQUEST });
        const { data } = await vdrData20YearsRequest(req);
        dispatch({ type: DATA_20_YEARS_QUARTERLY_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;
        if (error.response.data?.Message) {
            errorMsg = error.response?.data?.Message;
        } else {
            errorMsg = error.response?.data?.msg;
        }
        dispatch({ type: DATA_20_YEARS_QUARTERLY_FAIL, payload: errorMsg });
    }
};

export const vdrData20YearsAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: DATA_20_YEARS_REQUEST });
        const { data } = await vdrData20YearsRequest(req);
        dispatch({ type: DATA_20_YEARS_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;
        if (error.response.data?.Message) {
            errorMsg = error.response?.data?.Message;
        } else {
            errorMsg = error.response?.data?.msg;
        }
        dispatch({ type: DATA_20_YEARS_FAIL, payload: errorMsg });
    }
};

export const vdrPeerToPeerAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: PEER_TO_PEER_REQUEST });
        const { data } = await vdrPeerToPeerRequest(req);
        dispatch({ type: PEER_TO_PEER_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;
        if (error.response.data?.Message) {
            errorMsg = error.response?.data?.Message;
        } else {
            errorMsg = error.response?.data?.msg;
        }
        dispatch({ type: PEER_TO_PEER_FAIL, payload: errorMsg });
    }
};

export const vdrSortDataAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: SORT_DATA_REQUEST });
        const { data } = await vdrSortDataRequest(req);
        dispatch({ type: SORT_DATA_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;
        if (error.response.data?.Message) {
            errorMsg = error.response?.data?.Message;
        } else {
            errorMsg = error.response?.data?.msg;
        }
        dispatch({ type: SORT_DATA_FAIL, payload: errorMsg });
    }
};

export const vdrSortDataUpdateAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: SORT_DATA_UPDATE_REQUEST });
        const { data } = await vdrSortDataUpdateRequest(req);
        dispatch({ type: SORT_DATA_UPDATE_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;
        console.log(error)
        if (error.response.data?.Message) {
            errorMsg = error.response?.data?.Message;
        } else {
            errorMsg = error.response?.data?.msg;
        }
        dispatch({ type: SORT_DATA_UPDATE_FAIL, payload: errorMsg });
    }
};

export const vdrEmployeeAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: EMPLOYEE_REQUEST });
        const { data } = await vdrEmployeeRequest();
        dispatch({ type: EMPLOYEE_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;
        console.log(error)
        if (error.response.data?.Message) {
            errorMsg = error.response?.data?.Message;
        } else {
            errorMsg = error.response?.data?.msg;
        }
        dispatch({ type: EMPLOYEE_FAIL, payload: errorMsg });
    }
};


export const segmentAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: SEGMENT_REQUEST });
        const { data } = await vdrSegmentRequest(req);
        dispatch({ type: SEGMENT_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;
        console.log(error)
        if (error.response.data?.Message) {
            errorMsg = error.response?.data?.Message;
        } else {
            errorMsg = error.response?.data?.msg;
        }
        dispatch({ type: SEGMENT_FAIL, payload: errorMsg });
    }
};


export const segmentAssignAction = (req) => async (dispatch) => {
    try {
        dispatch({ type: SEGMENT_ASSIGN_REQUEST });
        const { data } = await vdrSegmentAssignRequest(req);
        dispatch({ type: SEGMENT_ASSIGN_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;
        console.log(error)
        if (error.response.data?.Message) {
            errorMsg = error.response?.data?.Message;
        } else {
            errorMsg = error.response?.data?.msg;
        }
        dispatch({ type: SEGMENT_ASSIGN_FAIL, payload: errorMsg });
    }
};


export const quarterlyReviewAction = (req) => async (dispatch) => {
    // console.log('error')
    try {
        dispatch({ type: QUARTERLY_REVIEW_REQUEST });
        const { data } = await quarterlyReviewRequest(req);
        dispatch({ type: QUARTERLY_REVIEW_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;
        console.log(error)
        if (error.response.data?.Message) {
            errorMsg = error.response?.data?.Message;
        } else {
            errorMsg = error.response?.data?.msg;
        }
        dispatch({ type: QUARTERLY_REVIEW_FAIL, payload: errorMsg });
    }
};

export const quarterlySegmentAction = (req, QuaterlySegmentType) => async (dispatch) => {
    // console.log('error')
    try {
        dispatch({ type: QUARTERLY_SEGMENT_REQUEST });
        let response;

        if(QuaterlySegmentType === "Standalone"){
            response = await quarterlySegmentStandaloneRequest(req);
        }else{
            response = await quarterlySegmentRequest(req);
        }
        const { data } = response;
        console.log('data >>> ', data)
        dispatch({ type: QUARTERLY_SEGMENT_SUCCESS, payload: data, currentType:QuaterlySegmentType });
    } catch (error) {
        var errorMsg;
        console.log(error)
        if (error.response.data?.Message) {
            errorMsg = error.response?.data?.Message;
        } else {
            errorMsg = error.response?.data?.msg;
        }
        dispatch({ type: QUARTERLY_SEGMENT_FAIL, payload: errorMsg });
    }
};


export const publicIpAction = () => async (dispatch) => {
    try {
        dispatch({ type: PUBLIC_IP_REQUEST });
        const { data } = await geoLocationDb();
        console.log(data);
        dispatch({ type: PUBLIC_IP_SUCCESS, payload: data });
    } catch (error) {
        var errorMsg;

        console.log(error)
        dispatch({ type: PUBLIC_IP_FAIL, payload: error });
    }
};

export const openPDFAction = (itemLink) => async (dispatch) => {
    try {
        dispatch({ type: PDF_LINK_REQUEST });

        dispatch({ type: PDF_LINK_SUCCESS, payload: itemLink });
    } catch (error) {
        var errorMsg;
        console.log(error)
    }
};

export const mediaModelAction = (type) => async (dispatch) => {
    try {
        dispatch({ type: MEDIA_MODEL_REQUEST });
        dispatch({ type: MEDIA_MODEL_OPEN, payload: type });
    } catch (error) {
        var errorMsg;
        console.log(error)
    }
};

